/**
 * Render a run's output counters (#1009).
 *
 * `files_created` is structurally 0 for connectors that merge straight into
 * the lakehouse (google_sheets hardcodes it at every return site), so showing
 * only files made those runs' output invisible — a run that wrote 0 tables
 * looked identical to one that wrote 141. Fall back to tables whenever no
 * files were written, so `0 tables` is stated rather than hidden.
 */
export function formatOutputCounts(files: number, tables: number): string {
  if (files > 0 && tables > 0) return `${files} files · ${tables} tables`;
  if (files > 0) return `${files} files`;
  return `${tables} tables`;
}
